import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SaveIcon from '@mui/icons-material/Save';
import TransparentButton from '@/trio-ui/TransparentButton';
import * as Styles from './JobBenefitsAndPerks.styles';
import DialogBox from '../DialogBox';
import Menu from '../Menu';
import SectionBox from '../SectionBox';

export type JobBenefitsAndPerksType = {
  id?: string;
  label: string;
  checked: boolean;
  isEditing: boolean;
  draft: string;
};

type JobBenefitsAndPerksProps = {
  listOfBenefitsAndPerks: any[];
  isAllChecked: boolean;
  isDeleteDialogOpen: boolean;
  onSelectAllPerks: () => void;
  addNewPerk: () => void;
  onSelectPerk: (index: number) => void;
  onSelectPerkToDelete: (index: number) => void;
  onCancelPerkToDelete: () => void;
  onDeletePerk: () => void;
  onEditPerk: (index: number) => void;
  onSavePerk: (benefit: JobBenefitsAndPerksType) => Promise<void>;
  onCancelEditingPerk: (index: number) => void;
  onChangePerk: (index: number, event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function JobBenefitsAndPerksComponent({
  listOfBenefitsAndPerks,
  isAllChecked,
  onEditPerk,
  onSavePerk,
  isDeleteDialogOpen,
  addNewPerk,
  onSelectAllPerks,
  onSelectPerk,
  onChangePerk,
  onSelectPerkToDelete,
  onCancelPerkToDelete,
  onCancelEditingPerk,
  onDeletePerk,
}: JobBenefitsAndPerksProps): JSX.Element {
  return (
    <>
      <SectionBox
        id="benefits-perks"
        title="Benefits & Perks"
        rightElement={
          <TransparentButton
            data-testid="add-new-benefit-or-perk-btn"
            onClick={addNewPerk}
            isBlueButton
          >
            + Add new benefit or perk
          </TransparentButton>
        }
      >
        <div data-testid="benefits-and-perks">
          <Styles.Box>
            <Styles.ListHeader>
              <Styles.CustomCheckbox
                checked={isAllChecked}
                onChange={onSelectAllPerks}
                id="check-all"
                name="check-all"
              />
              <p>Description</p>
            </Styles.ListHeader>
            <Styles.BenefitList>
              {listOfBenefitsAndPerks.map((perk, index) => {
                const id = `perk-id-${perk.id}`;
                return (
                  <Styles.BenefitRow data-testid="benefit-or-perk-item" key={id}>
                    <Styles.CustomCheckbox
                      onChange={() => onSelectPerk(index)}
                      id={id}
                      checked={perk.checked}
                      name={id}
                    />
                    <Styles.BenefitRowContent>
                      {perk.isEditing ? (
                        <Styles.EditingBenefitRow>
                          <Styles.CustomInputText
                            name={id}
                            value={perk.label}
                            onChangeHandler={(event) => onChangePerk(index, event)}
                          />
                          <TransparentButton
                            onClick={(event) => {
                              event.preventDefault();
                              onSavePerk(perk);
                            }}
                            icon={SaveIcon}
                            data-testid={`save-perk-btn-${perk.id}`}
                            isBlueButton
                          >
                            Save
                          </TransparentButton>
                          <TransparentButton
                            data-testid={`cancel-editing-perk-btn-${perk.id}`}
                            onClick={() => onCancelEditingPerk(index)}
                            icon={DeleteIcon}
                          >
                            Cancel
                          </TransparentButton>
                        </Styles.EditingBenefitRow>
                      ) : (
                        <Styles.EditingBenefitRow>
                          <Styles.BenefitText
                            role="button"
                            data-testid={`benefit-label-${index}`}
                            onClick={() => onSelectPerk(index)}
                            htmlFor={id}
                          >
                            {perk.label}
                          </Styles.BenefitText>
                          <Menu
                            icon={MoreHorizIcon}
                            menuId={`menu-id-${index}`}
                            menuItems={[
                              {
                                label: 'Edit',
                                menuItemIcon: CreateIcon,
                                callback: () => onEditPerk(index),
                              },
                              {
                                label: 'Delete',
                                menuItemOptions: { warning: true },
                                menuItemIcon: DeleteIcon,
                                callback: (event) => {
                                  event.stopPropagation();
                                  onSelectPerkToDelete(index);
                                },
                              },
                            ]}
                          />
                        </Styles.EditingBenefitRow>
                      )}
                    </Styles.BenefitRowContent>
                  </Styles.BenefitRow>
                );
              })}
            </Styles.BenefitList>
          </Styles.Box>

          <TransparentButton
            data-testid="add-new-benefit-or-perk-btn"
            onClick={addNewPerk}
            isBlueButton
          >
            + Add new benefit or perk
          </TransparentButton>
        </div>
      </SectionBox>

      <DialogBox
        isOpen={isDeleteDialogOpen}
        onCancelHandler={onCancelPerkToDelete}
        onConfirmHandler={() => onDeletePerk()}
      />
    </>
  );
}
